import React, { useState, useEffect } from 'react';
import {
  Table,
  Card,
  Tag,
  Space,
  Button,
  message,
  Descriptions,
  Image,
  Row,
  Col,
  Empty,
  Modal,
  Upload,
  Divider,
  InputNumber,
  Form,
  Checkbox,
  Tabs,
  List,
  Spin,
  Input,
  Avatar,
  Statistic,
} from 'antd';
import { EyeOutlined, CheckCircleOutlined, UploadOutlined, DeleteOutlined, CheckOutlined, SaveOutlined, EditOutlined, InboxOutlined, FileTextOutlined } from '@ant-design/icons';
import api, { getImageUrl } from '../services/api';
import dayjs from 'dayjs';
import { useAuth } from '../contexts/AuthContext';
import { getMontosDesdeServicio } from '../utils/montosServicio';
import PlanoCarro from '../components/PlanoCarro';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const MisServicios = () => {
  const { user } = useAuth();
  const [servicios, setServicios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedServicio, setSelectedServicio] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [uploadingImages, setUploadingImages] = useState(false);
  const [finalizarModalVisible, setFinalizarModalVisible] = useState(false);
  const [formFinalizar] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [estadoPendiente, setEstadoPendiente] = useState('completado');
  const [ultimoIdServicio, setUltimoIdServicio] = useState(null);
  const [formPlanoChecklist] = Form.useForm();
  const [editandoPlanoChecklist, setEditandoPlanoChecklist] = useState(false);
  const [seguimientoMensajes, setSeguimientoMensajes] = useState([]);
  const [cargandoSeguimiento, setCargandoSeguimiento] = useState(false);
  const [nuevoMensaje, setNuevoMensaje] = useState('');
  const [imagenSeguimiento, setImagenSeguimiento] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [resumenModalVisible, setResumenModalVisible] = useState(false);
  const [cajaChica, setCajaChica] = useState(null);
  const [gastosCajaChica, setGastosCajaChica] = useState([]);

  // Items del checklist (mismo que en Servicios.js)
  const checklistItems = [
    { key: 'tarjeta_propiedad', label: 'Tarjeta de Propiedad' },
    { key: 'soat', label: 'SOAT' },
    { key: 'cabeceras', label: 'Cabeceras' },
    { key: 'llave_control', label: 'Llave - Control/R' },
    { key: 'encendedor', label: 'Encendedor' },
    { key: 'radio_mascarilla', label: 'Radio - Mascarilla' },
    { key: 'parlantes', label: 'Parlantes' },
    { key: 'ceniceros', label: 'Ceniceros' },
    { key: 'tapa_sol', label: 'Tapa sol' },
    { key: 'tapa_radiador', label: 'Tapa de Radiador' },
    { key: 'varilla_aceite', label: 'Varilla de Aceite' },
    { key: 'pisos', label: 'Pisos' },
    { key: 'faros_delanteros', label: 'Faros Delanteros' },
    { key: 'faros_posteriores', label: 'Faros Posteriores' },
    { key: 'plumillas', label: 'Plumillas' },
    { key: 'tapa_combustible', label: 'Tapa Combustible' },
    { key: 'antena', label: 'Antena' },
    { key: 'espejo_interior', label: 'Espejo Interior' },
    { key: 'espejo_exterior', label: 'Espejo Exterior' },
    { key: 'bateria', label: 'Bateria' },
    { key: 'tapa_aceite', label: 'Tapa de Aceite' },
    { key: 'extintor', label: 'Extintor' },
    { key: 'triangulo_cono', label: 'Triangulo / Cono' },
    { key: 'seguro_rueda', label: 'Seguro de Rueda' },
    { key: 'gata', label: 'Gata' },
    { key: 'llave_rueda', label: 'Llave / Rueda' },
    { key: 'vasos_copas', label: 'Vasos / Copas' },
    { key: 'aros', label: 'Aros' },
    { key: 'llanta_repuesto', label: 'Llanta / Repuesto' },
  ];

  useEffect(() => {
    if (user && user.personal_id) {
      fetchServicios();

      // Auto-refresh cada 30 segundos para verificar nuevos servicios
      const interval = setInterval(() => {
        fetchServicios();
      }, 30000); // 30 segundos

      return () => clearInterval(interval);
    }
  }, [user]);

  // Efecto para cargar el kilometraje cuando se abre el modal de finalizar
  useEffect(() => {
    if (finalizarModalVisible && selectedServicio) {
      const cargarKilometraje = async () => {
        try {
          let kmActual = null;
          let unidadId = selectedServicio?.unidad_id;

          console.log('Cargando kilometraje para servicio:', selectedServicio.id);
          console.log('unidad_id del servicio:', unidadId);

          // Si el servicio no tiene unidad_id, intentar obtenerlo desde la asistencia del trabajador
          if (!unidadId && user?.personal_id) {
            try {
              const asistenciaResponse = await api.get(`/asistencias?personal_id=${user.personal_id}&unidad=1`);
              if (asistenciaResponse.data && asistenciaResponse.data.unidad_id) {
                unidadId = asistenciaResponse.data.unidad_id;
                console.log('Unidad obtenida desde asistencia:', unidadId);
              }
            } catch (error) {
              console.error('Error al obtener unidad desde asistencia:', error);
            }
          }

          // Obtener el kilometraje actual directamente de la unidad
          if (unidadId) {
            try {
              const unidadResponse = await api.get(`/unidades/${unidadId}`);
              console.log('Respuesta de unidad:', unidadResponse.data);
              if (unidadResponse.data && unidadResponse.data.km_actual !== null && unidadResponse.data.km_actual !== undefined) {
                kmActual = parseFloat(unidadResponse.data.km_actual);
                console.log('Kilometraje actual obtenido desde unidad:', kmActual);
              }
            } catch (error) {
              console.error('Error al obtener información de la unidad:', error);
            }
          } else {
            console.log('No se pudo obtener unidad_id del servicio ni de la asistencia');
          }

          console.log('Valor a establecer:', kmActual);

          if (kmActual !== null && kmActual !== undefined) {
            // Usar setTimeout para asegurar que el formulario esté completamente renderizado
            setTimeout(() => {
              formFinalizar.setFieldsValue({
                km_fin: kmActual
              });
              console.log('Valor establecido en el formulario:', kmActual);
            }, 200);
          }
        } catch (error) {
          console.error('Error al cargar kilometraje:', error);
        }
      };

      cargarKilometraje();
    } else if (!finalizarModalVisible) {
      // Resetear el formulario cuando se cierra el modal
      formFinalizar.resetFields();
    }
  }, [finalizarModalVisible, selectedServicio, user]);

  const fetchServicios = async () => {
    if (!user || !user.personal_id) {
      message.warning('No se encontró información del personal');
      return;
    }

    setLoading(true);
    try {
      const response = await api.get('/servicios');
      // Filtrar solo los servicios asignados a este personal
      const misServicios = response.data.filter(
        s => s.trabajador_id && s.trabajador_id.toString() === user.personal_id.toString()
      );

      // Detectar si hay nuevos servicios
      if (ultimoIdServicio !== null && misServicios.length > 0) {
        const nuevoServicio = misServicios.find(s => s.id > ultimoIdServicio);
        if (nuevoServicio) {
          // Reproducir sonido y vibrar si hay nuevo servicio
          try {
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();

            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);

            oscillator.frequency.value = 600;
            oscillator.type = 'sine';

            gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
            gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

            oscillator.start(audioContext.currentTime);
            oscillator.stop(audioContext.currentTime + 0.5);
          } catch (error) {
            console.error('Error al reproducir sonido:', error);
          }

          // Vibrar si está disponible
          if ('vibrate' in navigator) {
            try {
              navigator.vibrate([200, 100, 200]);
            } catch (error) {
              console.error('Error al vibrar:', error);
            }
          }

          message.info('¡Tienes un nuevo servicio asignado!');
        }
      }

      // Actualizar el último ID de servicio
      if (misServicios.length > 0) {
        const maxId = Math.max(...misServicios.map(s => s.id));
        setUltimoIdServicio(maxId);
      }

      setServicios(misServicios);
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchSeguimiento = async (servicioId) => {
    setCargandoSeguimiento(true);
    try {
      const response = await api.get(`/seguimiento?servicio_id=${servicioId}`);
      setSeguimientoMensajes(response.data || []);
    } catch (error) {
      console.error('Error al cargar seguimiento:', error);
      setSeguimientoMensajes([]);
    } finally {
      setCargandoSeguimiento(false);
    }
  };

  const handleEnviarMensaje = async () => {
    if (!selectedServicio?.id) return;

    if (!nuevoMensaje.trim() && !imagenSeguimiento) {
      message.warning('Ingresa un mensaje o adjunta una imagen');
      return;
    }

    try {
      let imagenUrl = null;

      // Si hay imagen, subirla primero
      if (imagenSeguimiento) {
        const formData = new FormData();
        formData.append('imagenes', imagenSeguimiento);
        const uploadResponse = await api.post('/servicios/upload-images', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        imagenUrl = uploadResponse.data.urls[0];
      }

      // Enviar mensaje
      const response = await api.post('/seguimiento', {
        servicio_id: selectedServicio.id,
        mensaje: nuevoMensaje.trim() || null,
        imagen: imagenUrl
      });

      // Agregar el nuevo mensaje a la lista
      setSeguimientoMensajes([...seguimientoMensajes, response.data]);
      setNuevoMensaje('');
      setImagenSeguimiento(null);
      message.success('Mensaje enviado');
    } catch (error) {
      console.error('Error al enviar mensaje:', error);
      message.error(error.message);
    }
  };

  const handleEliminarMensaje = async (mensajeId) => {
    try {
      await api.delete(`/seguimiento/${mensajeId}`);
      setSeguimientoMensajes(seguimientoMensajes.filter(m => m.id !== mensajeId));
      message.success('Mensaje eliminado');
    } catch (error) {
      console.error('Error al eliminar mensaje:', error);
      message.error(error.message);
    }
  };

  const handleVerDetalle = (record) => {
    setSelectedServicio(record);
    setFileList([]); // Limpiar lista de archivos al abrir el modal
    setEditandoPlanoChecklist(true); // Habilitar edición por defecto
    setActiveTab('1'); // Resetear a la primera pestaña
    setModalVisible(true);

    // Cargar mensajes de seguimiento
    if (record.id) {
      fetchSeguimiento(record.id);
    }

    // Cargar valores del plano y checklist en el formulario
    setTimeout(() => {
      const formValues = {
        fallas_mecanicas: record.fallas_mecanicas || [],
      };

      // Cargar valores del checklist
      if (record.checklist) {
        Object.keys(record.checklist).forEach(key => {
          if (key !== 'id' && key !== 'servicio_id') {
            formValues[key] = record.checklist[key];
          }
        });
      }

      formPlanoChecklist.setFieldsValue(formValues);
    }, 100);
  };

  const handleGuardarPlanoChecklist = async (values) => {
    if (!selectedServicio || !selectedServicio.id) {
      message.error('No hay servicio seleccionado');
      return;
    }

    try {
      // Separar campos del checklist
      const checklistFields = checklistItems.map(item => item.key);
      const checklistData = {};
      const servicioData = {};

      Object.keys(values).forEach(key => {
        if (checklistFields.includes(key)) {
          checklistData[key] = values[key];
        } else if (key === 'fallas_mecanicas') {
          servicioData[key] = values[key] || [];
        }
      });

      // Actualizar el servicio
      const updateData = {
        fallas_mecanicas: servicioData.fallas_mecanicas || [],
        checklist: checklistData,
      };

      await api.put(`/servicios/${selectedServicio.id}`, updateData);

      // Actualizar el servicio seleccionado
      setSelectedServicio({
        ...selectedServicio,
        fallas_mecanicas: servicioData.fallas_mecanicas || [],
        checklist: { ...selectedServicio.checklist, ...checklistData },
      });

      // Refrescar la lista de servicios
      await fetchServicios();

      setEditandoPlanoChecklist(false);
      message.success('Plano y checklist actualizados exitosamente');
    } catch (error) {
      console.error('Error al actualizar plano y checklist:', error);
      message.error(error.message);
    }
  };

  const handleDeleteImage = async (imageUrl, index) => {
    if (!selectedServicio || !selectedServicio.id) {
      message.error('No hay servicio seleccionado');
      return;
    }

    try {
      const imagenesActuales = selectedServicio.imagenes || [];
      // Normalizar imágenes a formato de objetos
      const imagenesNormalizadas = imagenesActuales.map(img =>
        typeof img === 'string' ? { url: img, descripcion: '' } : img
      );
      const nuevasImagenes = imagenesNormalizadas.filter((_, i) => i !== index);

      await api.put(`/servicios/${selectedServicio.id}`, {
        imagenes: nuevasImagenes
      });

      setSelectedServicio({
        ...selectedServicio,
        imagenes: nuevasImagenes
      });

      fetchServicios();
      message.success('Imagen eliminada exitosamente');
    } catch (error) {
      message.error(error.message);
    }
  };

  const handleCambiarEstado = async (nuevoEstado, kmFin = null) => {
    if (!selectedServicio || !selectedServicio.id) {
      message.error('No hay servicio seleccionado');
      return;
    }

    try {
      const updateData = {
        estado: nuevoEstado
      };

      // Si se está finalizando o cancelando y hay km_fin, incluirlo
      if ((nuevoEstado === 'completado' || nuevoEstado === 'cancelado') && kmFin !== null) {
        updateData.km_fin = kmFin;
      }

      await api.put(`/servicios/${selectedServicio.id}`, updateData);

      setSelectedServicio({
        ...selectedServicio,
        estado: nuevoEstado,
        km_fin: kmFin !== null ? kmFin : selectedServicio.km_fin
      });

      fetchServicios();
      message.success('Estado del servicio actualizado exitosamente');
      setFinalizarModalVisible(false);
      formFinalizar.resetFields();
    } catch (error) {
      message.error(error.message);
    }
  };

  const handleFinalizarServicio = () => {
    setFinalizarModalVisible(true);
  };

  const handleConfirmarFinalizar = async (values, estado = 'completado') => {
    await handleCambiarEstado(estado, values.km_fin);
  };

  const getEstadoColor = (estado) => {
    const colores = {
      pendiente: 'orange',
      en_proceso: 'blue',
      completado: 'green',
      cancelado: 'red',
    };
    return colores[estado] || 'default';
  };

  const getEstadoLabel = (estado) => {
    const labels = {
      pendiente: 'PENDIENTE',
      en_proceso: 'EN PROCESO',
      completado: 'COMPLETADO',
      cancelado: 'ANULADO',
    };
    return labels[estado] || estado?.toUpperCase() || '-';
  };

  // Determinar qué botones mostrar según el estado actual
  const getBotonesEstadoDisponibles = (estadoActual) => {
    const botones = [];

    // Solo se puede cambiar a: en_proceso, completado, cancelado
    // No se puede cambiar desde completado o cancelado
    if (estadoActual === 'completado' || estadoActual === 'cancelado') {
      return botones; // No mostrar botones si ya está completado o cancelado
    }

    // Desde pendiente o en_proceso se puede cambiar a:
    if (estadoActual !== 'en_proceso') {
      botones.push({ estado: 'en_proceso', label: 'En Proceso', color: 'blue' });
    }

    if (estadoActual !== 'completado') {
      botones.push({ estado: 'completado', label: 'Completar', color: 'green' });
    }

    if (estadoActual !== 'cancelado') {
      botones.push({ estado: 'cancelado', label: 'Cancelar', color: 'red' });
    }

    return botones;
  };

  const fetchResumenDiario = async () => {
    if (!user || !user.personal_id) return;

    try {
      // Obtener servicios del día
      const serviciosResponse = await api.get('/servicios');
      const serviciosHoy = serviciosResponse.data.filter(s => {
        if (s.trabajador_id && s.trabajador_id.toString() === user.personal_id.toString()) {
          const fechaServicio = dayjs(s.fecha_solicitud || s.created_at);
          return fechaServicio.isSame(dayjs(), 'day');
        }
        return false;
      });

      // Obtener caja chica en curso o última liquidada
      try {
        const cajaChicaResponse = await api.get('/caja-chica');
        const misCajasChica = cajaChicaResponse.data.filter(
          c => c.personal_id === user.personal_id
        );

        // Buscar caja chica en curso
        let miCajaChica = misCajasChica.find(c => c.estado === 'en_curso');

        // Si no hay en curso, buscar la última liquidada
        if (!miCajaChica) {
          const liquidadas = misCajasChica
            .filter(c => c.estado === 'liquidado')
            .sort((a, b) => {
              const fechaA = a.fecha_liquidacion ? new Date(a.fecha_liquidacion) : new Date(0);
              const fechaB = b.fecha_liquidacion ? new Date(b.fecha_liquidacion) : new Date(0);
              return fechaB - fechaA; // Orden descendente
            });
          if (liquidadas.length > 0) {
            miCajaChica = liquidadas[0];
          }
        }

        if (miCajaChica) {
          setCajaChica(miCajaChica);
          // Obtener gastos de la caja chica
          const gastosResponse = await api.get('/gastos-caja-chica');
          const misGastos = gastosResponse.data.filter(
            g => g.caja_chica_id === miCajaChica.id
          );
          setGastosCajaChica(misGastos);
        } else {
          setCajaChica(null);
          setGastosCajaChica([]);
        }
      } catch (error) {
        console.error('Error al obtener caja chica:', error);
        setCajaChica(null);
        setGastosCajaChica([]);
      }

      setResumenModalVisible(true);
    } catch (error) {
      message.error(error.message);
    }
  };

  const calcularResumenServicios = () => {
    if (!user || !user.personal_id) return { total: 0, completados: 0, enProceso: 0, pendientes: 0 };

    const serviciosHoy = servicios.filter(s => {
      if (s.trabajador_id && s.trabajador_id.toString() === user.personal_id.toString()) {
        const fechaServicio = dayjs(s.fecha_solicitud || s.created_at);
        return fechaServicio.isSame(dayjs(), 'day');
      }
      return false;
    });

    return {
      total: serviciosHoy.length,
      completados: serviciosHoy.filter(s => s.estado === 'completado').length,
      enProceso: serviciosHoy.filter(s => s.estado === 'en_proceso').length,
      pendientes: serviciosHoy.filter(s => s.estado === 'pendiente').length,
    };
  };

  const calcularResumenCajaChica = () => {
    if (!cajaChica) return null;

    const gastosEfectivo = gastosCajaChica.filter(
      g => (g.tipo_pago === 'efectivo' || !g.tipo_pago) && g.estado === 'aprobado'
    );
    const gastosTarjeta = gastosCajaChica.filter(
      g => g.tipo_pago === 'tarjeta' && g.estado === 'aprobado'
    );

    const totalGastosEfectivo = gastosEfectivo.reduce((sum, g) => sum + parseFloat(g.monto || 0), 0);
    const totalGastosTarjeta = gastosTarjeta.reduce((sum, g) => sum + parseFloat(g.monto || 0), 0);

    return {
      montoAsignado: parseFloat(cajaChica.monto_asignado || 0),
      tarjetaCombustible: parseFloat(cajaChica.tarjeta_combustible || 0),
      efectivoDisponible: parseFloat(cajaChica.monto_asignado || 0) - totalGastosEfectivo,
      tarjetaDisponible: parseFloat(cajaChica.tarjeta_combustible || 0) - totalGastosTarjeta,
      totalGastosEfectivo,
      totalGastosTarjeta,
      totalGastos: gastosCajaChica.length,
    };
  };

  const handleExportarResumenPDF = async () => {
    if (!user || !user.personal_id) return;

    try {
      message.loading({ content: 'Generando PDF...', key: 'export' });

      // Obtener servicios del día
      const serviciosResponse = await api.get('/servicios');
      const serviciosHoy = serviciosResponse.data.filter(s => {
        if (s.trabajador_id && s.trabajador_id.toString() === user.personal_id.toString()) {
          const fechaServicio = dayjs(s.fecha_solicitud || s.created_at);
          return fechaServicio.isSame(dayjs(), 'day');
        }
        return false;
      });

      const resumenServicios = calcularResumenServicios();

      // Obtener caja chica (en curso o última liquidada)
      let cajaChicaData = null;
      let gastosCajaChicaData = [];

      try {
        const cajaChicaResponse = await api.get('/caja-chica');
        const misCajasChica = cajaChicaResponse.data.filter(
          c => c.personal_id === user.personal_id
        );

        let miCajaChica = misCajasChica.find(c => c.estado === 'en_curso');

        if (!miCajaChica) {
          const liquidadas = misCajasChica
            .filter(c => c.estado === 'liquidado')
            .sort((a, b) => {
              const fechaA = a.fecha_liquidacion ? new Date(a.fecha_liquidacion) : new Date(0);
              const fechaB = b.fecha_liquidacion ? new Date(b.fecha_liquidacion) : new Date(0);
              return fechaB - fechaA;
            });
          if (liquidadas.length > 0) {
            miCajaChica = liquidadas[0];
          }
        }

        if (miCajaChica) {
          cajaChicaData = miCajaChica;
          const gastosResponse = await api.get('/gastos-caja-chica');
          gastosCajaChicaData = gastosResponse.data.filter(
            g => g.caja_chica_id === miCajaChica.id
          );
        }
      } catch (error) {
        console.error('Error al obtener caja chica:', error);
      }

      // Calcular resumen de caja chica
      let resumenCaja = null;
      if (cajaChicaData) {
        const gastosEfectivo = gastosCajaChicaData.filter(
          g => (g.tipo_pago === 'efectivo' || !g.tipo_pago) && g.estado === 'aprobado'
        );
        const gastosTarjeta = gastosCajaChicaData.filter(
          g => g.tipo_pago === 'tarjeta' && g.estado === 'aprobado'
        );

        const totalGastosEfectivo = gastosEfectivo.reduce((sum, g) => sum + parseFloat(g.monto || 0), 0);
        const totalGastosTarjeta = gastosTarjeta.reduce((sum, g) => sum + parseFloat(g.monto || 0), 0);

        resumenCaja = {
          montoAsignado: parseFloat(cajaChicaData.monto_asignado || 0),
          tarjetaCombustible: parseFloat(cajaChicaData.tarjeta_combustible || 0),
          efectivoDisponible: parseFloat(cajaChicaData.monto_asignado || 0) - totalGastosEfectivo,
          tarjetaDisponible: parseFloat(cajaChicaData.tarjeta_combustible || 0) - totalGastosTarjeta,
          totalGastosEfectivo,
          totalGastosTarjeta,
          totalGastos: gastosCajaChicaData.length,
          estado: cajaChicaData.estado,
          fechaApertura: cajaChicaData.fecha_apertura,
          fechaLiquidacion: cajaChicaData.fecha_liquidacion,
          devolucion: cajaChicaData.devolucion,
          gastosEfectivo,
          gastosTarjeta,
        };
      }

      // Crear elemento temporal para el PDF
      const div = document.createElement('div');
      div.style.width = '210mm';
      div.style.padding = '20mm';
      div.style.fontFamily = 'Arial, sans-serif';
      div.style.backgroundColor = '#fff';
      div.style.position = 'absolute';
      div.style.left = '-9999px';
      document.body.appendChild(div);

      // Contenido del PDF
      div.innerHTML = `
        <div style="text-align: center; margin-bottom: 30px;">
          <h1 style="margin: 0; font-size: 24px; color: #1890ff;">Resumen Diario</h1>
          <p style="margin: 5px 0; font-size: 14px; color: #666;">Fecha: ${dayjs().format('DD/MM/YYYY HH:mm')}</p>
          <p style="margin: 5px 0; font-size: 14px; color: #666;">Operario: ${user.nombre || '-'}</p>
        </div>
        
        <div style="margin-bottom: 30px; border: 1px solid #d9d9d9; padding: 15px; border-radius: 4px;">
          <h2 style="margin: 0 0 15px 0; font-size: 18px; color: #333;">Resumen de Servicios del Día</h2>
          <table style="width: 100%; border-collapse: collapse;">
            <tr>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; font-weight: bold; width: 50%;">Total Servicios:</td>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; color: #1890ff; font-size: 16px;">${resumenServicios.total}</td>
            </tr>
            <tr>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; font-weight: bold;">Completados:</td>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; color: #3f8600; font-size: 16px;">${resumenServicios.completados}</td>
            </tr>
            <tr>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; font-weight: bold;">En Proceso:</td>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; color: #1890ff; font-size: 16px;">${resumenServicios.enProceso}</td>
            </tr>
            <tr>
              <td style="padding: 8px; font-weight: bold;">Pendientes:</td>
              <td style="padding: 8px; color: #faad14; font-size: 16px;">${resumenServicios.pendientes}</td>
            </tr>
          </table>
        </div>
        
        ${serviciosHoy.length > 0 ? `
        <div style="margin-bottom: 30px;">
          <h2 style="margin: 0 0 15px 0; font-size: 18px; color: #333;">Detalle de Servicios</h2>
          <table style="width: 100%; border-collapse: collapse; border: 1px solid #d9d9d9;">
            <thead>
              <tr style="background-color: #fafafa;">
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: left; font-size: 12px;">ID</th>
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: left; font-size: 12px;">Cliente</th>
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: left; font-size: 12px;">Estado</th>
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: left; font-size: 12px;">Fecha</th>
              </tr>
            </thead>
            <tbody>
              ${serviciosHoy.map((servicio, index) => `
                <tr style="${index % 2 === 0 ? 'background-color: #fafafa;' : ''}">
                  <td style="padding: 8px; border: 1px solid #d9d9d9; font-size: 11px;">${servicio.id}</td>
                  <td style="padding: 8px; border: 1px solid #d9d9d9; font-size: 11px;">${servicio.cliente_nombre ? `${servicio.cliente_nombre} ${servicio.cliente_apellido || ''}`.trim() : '-'}</td>
                  <td style="padding: 8px; border: 1px solid #d9d9d9; font-size: 11px;">${getEstadoLabel(servicio.estado)}</td>
                  <td style="padding: 8px; border: 1px solid #d9d9d9; font-size: 11px;">${servicio.fecha_solicitud ? dayjs(servicio.fecha_solicitud).format('DD/MM/YYYY HH:mm') : '-'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
        ` : ''}
        
        ${resumenCaja ? `
        <div style="margin-bottom: 30px; border: 1px solid #d9d9d9; padding: 15px; border-radius: 4px;">
          <h2 style="margin: 0 0 15px 0; font-size: 18px; color: #333;">Resumen de Caja Chica - ${resumenCaja.estado === 'en_curso' ? 'En Curso' : 'Liquidada'}</h2>
          <table style="width: 100%; border-collapse: collapse;">
            <tr>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; font-weight: bold; width: 50%;">Estado:</td>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0;">${resumenCaja.estado === 'en_curso' ? 'En Curso' : 'Liquidada'}</td>
            </tr>
            ${resumenCaja.fechaApertura ? `
            <tr>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; font-weight: bold;">Fecha Apertura:</td>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0;">${dayjs(resumenCaja.fechaApertura).format('DD/MM/YYYY')}</td>
            </tr>
            ` : ''}
            ${resumenCaja.fechaLiquidacion ? `
            <tr>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; font-weight: bold;">Fecha Liquidación:</td>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0;">${dayjs(resumenCaja.fechaLiquidacion).format('DD/MM/YYYY')}</td>
            </tr>
            ` : ''}
          </table>
        </div>
        
        <div style="margin-bottom: 30px; border: 1px solid #d9d9d9; padding: 15px; border-radius: 4px;">
          <h2 style="margin: 0 0 15px 0; font-size: 18px; color: #333;">Resumen Financiero - Efectivo</h2>
          <table style="width: 100%; border-collapse: collapse;">
            <tr>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; font-weight: bold; width: 50%;">Monto Asignado:</td>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; color: #1890ff; font-size: 16px;">S/ ${resumenCaja.montoAsignado.toFixed(2)}</td>
            </tr>
            <tr>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; font-weight: bold;">Gastos en Efectivo:</td>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; color: #cf1322; font-size: 16px;">S/ ${resumenCaja.totalGastosEfectivo.toFixed(2)}</td>
            </tr>
            <tr>
              <td style="padding: 8px; font-weight: bold;">Efectivo Disponible:</td>
              <td style="padding: 8px; color: ${resumenCaja.efectivoDisponible >= 0 ? '#3f8600' : '#cf1322'}; font-size: 16px;">S/ ${resumenCaja.efectivoDisponible.toFixed(2)}</td>
            </tr>
          </table>
        </div>
        
        <div style="margin-bottom: 30px; border: 1px solid #d9d9d9; padding: 15px; border-radius: 4px;">
          <h2 style="margin: 0 0 15px 0; font-size: 18px; color: #333;">Resumen Financiero - Tarjeta</h2>
          <table style="width: 100%; border-collapse: collapse;">
            <tr>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; font-weight: bold; width: 50%;">Tarjeta de Combustible:</td>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; color: #1890ff; font-size: 16px;">S/ ${resumenCaja.tarjetaCombustible.toFixed(2)}</td>
            </tr>
            <tr>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; font-weight: bold;">Gastos en Tarjeta:</td>
              <td style="padding: 8px; border-bottom: 1px solid #f0f0f0; color: #cf1322; font-size: 16px;">S/ ${resumenCaja.totalGastosTarjeta.toFixed(2)}</td>
            </tr>
            <tr>
              <td style="padding: 8px; font-weight: bold;">Tarjeta Disponible:</td>
              <td style="padding: 8px; color: ${resumenCaja.tarjetaDisponible >= 0 ? '#3f8600' : '#cf1322'}; font-size: 16px;">S/ ${resumenCaja.tarjetaDisponible.toFixed(2)}</td>
            </tr>
          </table>
        </div>
        
        ${resumenCaja.estado === 'liquidado' && resumenCaja.devolucion ? `
        <div style="margin-bottom: 30px; border: 1px solid #d9d9d9; padding: 15px; border-radius: 4px;">
          <h2 style="margin: 0 0 15px 0; font-size: 18px; color: #333;">Liquidación</h2>
          <table style="width: 100%; border-collapse: collapse;">
            <tr>
              <td style="padding: 8px; font-weight: bold; width: 50%;">Devolución:</td>
              <td style="padding: 8px; font-size: 16px;">S/ ${parseFloat(resumenCaja.devolucion || 0).toFixed(2)}</td>
            </tr>
          </table>
        </div>
        ` : ''}
        
        ${resumenCaja.gastosEfectivo.length > 0 ? `
        <div style="margin-bottom: 20px;">
          <h2 style="margin: 0 0 15px 0; font-size: 18px; color: #333;">Detalle de Gastos en Efectivo</h2>
          <table style="width: 100%; border-collapse: collapse; border: 1px solid #d9d9d9; margin-bottom: 20px;">
            <thead>
              <tr style="background-color: #fafafa;">
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: left; font-size: 12px;">Fecha</th>
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: left; font-size: 12px;">Tipo</th>
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: right; font-size: 12px;">Monto</th>
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: left; font-size: 12px;">Descripción</th>
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: center; font-size: 12px;">Estado</th>
              </tr>
            </thead>
            <tbody>
              ${resumenCaja.gastosEfectivo.map((gasto, index) => `
                <tr style="${index % 2 === 0 ? 'background-color: #fafafa;' : ''}">
                  <td style="padding: 8px; border: 1px solid #d9d9d9; font-size: 11px;">${gasto.fecha_gasto ? dayjs(gasto.fecha_gasto).format('DD/MM/YYYY') : '-'}</td>
                  <td style="padding: 8px; border: 1px solid #d9d9d9; font-size: 11px;">${gasto.tipo_gasto ? gasto.tipo_gasto.toUpperCase() : '-'}</td>
                  <td style="padding: 8px; border: 1px solid #d9d9d9; text-align: right; font-size: 11px;">S/ ${parseFloat(gasto.monto || 0).toFixed(2)}</td>
                  <td style="padding: 8px; border: 1px solid #d9d9d9; font-size: 11px;">${gasto.descripcion || '-'}</td>
                  <td style="padding: 8px; border: 1px solid #d9d9d9; text-align: center; font-size: 11px;">
                    ${gasto.estado === 'aprobado' ? '✓ Aprobado' : gasto.estado === 'rechazado' ? '✗ Rechazado' : '⏳ Pendiente'}
                  </td>
                </tr>
              `).join('')}
              <tr style="background-color: #f0f0f0; font-weight: bold;">
                <td colspan="2" style="padding: 10px; border: 1px solid #d9d9d9; text-align: right; font-size: 12px;">TOTAL EFECTIVO:</td>
                <td style="padding: 10px; border: 1px solid #d9d9d9; text-align: right; font-size: 12px;">
                  S/ ${resumenCaja.totalGastosEfectivo.toFixed(2)}
                </td>
                <td colspan="2" style="padding: 10px; border: 1px solid #d9d9d9;"></td>
              </tr>
            </tbody>
          </table>
        </div>
        ` : ''}
        
        ${resumenCaja.gastosTarjeta.length > 0 ? `
        <div style="margin-bottom: 20px;">
          <h2 style="margin: 0 0 15px 0; font-size: 18px; color: #333;">Detalle de Gastos en Tarjeta</h2>
          <table style="width: 100%; border-collapse: collapse; border: 1px solid #d9d9d9;">
            <thead>
              <tr style="background-color: #fafafa;">
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: left; font-size: 12px;">Fecha</th>
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: left; font-size: 12px;">Tipo</th>
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: right; font-size: 12px;">Monto</th>
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: left; font-size: 12px;">Descripción</th>
                <th style="padding: 10px; border: 1px solid #d9d9d9; text-align: center; font-size: 12px;">Estado</th>
              </tr>
            </thead>
            <tbody>
              ${resumenCaja.gastosTarjeta.map((gasto, index) => `
                <tr style="${index % 2 === 0 ? 'background-color: #fafafa;' : ''}">
                  <td style="padding: 8px; border: 1px solid #d9d9d9; font-size: 11px;">${gasto.fecha_gasto ? dayjs(gasto.fecha_gasto).format('DD/MM/YYYY') : '-'}</td>
                  <td style="padding: 8px; border: 1px solid #d9d9d9; font-size: 11px;">${gasto.tipo_gasto ? gasto.tipo_gasto.toUpperCase() : '-'}</td>
                  <td style="padding: 8px; border: 1px solid #d9d9d9; text-align: right; font-size: 11px;">S/ ${parseFloat(gasto.monto || 0).toFixed(2)}</td>
                  <td style="padding: 8px; border: 1px solid #d9d9d9; font-size: 11px;">${gasto.descripcion || '-'}</td>
                  <td style="padding: 8px; border: 1px solid #d9d9d9; text-align: center; font-size: 11px;">
                    ${gasto.estado === 'aprobado' ? '✓ Aprobado' : gasto.estado === 'rechazado' ? '✗ Rechazado' : '⏳ Pendiente'}
                  </td>
                </tr>
              `).join('')}
              <tr style="background-color: #f0f0f0; font-weight: bold;">
                <td colspan="2" style="padding: 10px; border: 1px solid #d9d9d9; text-align: right; font-size: 12px;">TOTAL TARJETA:</td>
                <td style="padding: 10px; border: 1px solid #d9d9d9; text-align: right; font-size: 12px;">
                  S/ ${resumenCaja.totalGastosTarjeta.toFixed(2)}
                </td>
                <td colspan="2" style="padding: 10px; border: 1px solid #d9d9d9;"></td>
              </tr>
            </tbody>
          </table>
        </div>
        ` : ''}
        ` : '<div style="margin-bottom: 30px;"><p style="color: #999; font-style: italic;">No hay caja chica asignada</p></div>'}
      `;

      // Esperar a que se renderice el contenido
      await new Promise(resolve => setTimeout(resolve, 500));

      // Generar el PDF con mejor manejo de páginas
      const canvas = await html2canvas(div, {
        scale: 2,
        useCORS: true,
        logging: false,
        windowWidth: div.scrollWidth,
        windowHeight: div.scrollHeight,
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 210;
      const pageHeight = 297;
      const margin = 10;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      // Agregar primera página
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= (pageHeight - margin);

      // Agregar páginas adicionales si es necesario
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= (pageHeight - margin);
      }

      // Limpiar
      document.body.removeChild(div);

      // Descargar PDF
      pdf.save(`Resumen_Diario_${dayjs().format('YYYY-MM-DD')}.pdf`);

      message.success({ content: 'PDF generado exitosamente', key: 'export' });
    } catch (error) {
      console.error('Error al generar PDF:', error);
      message.error({ content: error.message, key: 'export' });
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: 'Cliente',
      key: 'cliente',
      render: (_, record) => {
        if (record.cliente_nombre) {
          return `${record.cliente_nombre} ${record.cliente_apellido || ''}`.trim();
        }
        return record.cliente_id || '-';
      },
    },
    {
      title: 'Lugar de Contacto',
      dataIndex: 'lugar_contacto',
      key: 'lugar_contacto',
      render: (text) => text || '-',
    },
    {
      title: 'Lugar de Destino',
      dataIndex: 'lugar_destino',
      key: 'lugar_destino',
      render: (text) => text || '-',
    },
    {
      title: 'Tipo de Servicio',
      dataIndex: 'tipo_servicio_nombre',
      key: 'tipo_servicio_nombre',
      render: (text) => text || '-',
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      key: 'estado',
      render: (estado) => (
        <Tag color={getEstadoColor(estado)}>
          {getEstadoLabel(estado)}
        </Tag>
      ),
    },
    {
      title: 'Fecha Solicitud',
      dataIndex: 'fecha_solicitud',
      key: 'fecha_solicitud',
      render: (fecha) => fecha ? dayjs(fecha).format('DD/MM/YYYY HH:mm') : '-',
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (_, record) => (
        <Button
          type="primary"
          icon={<EyeOutlined />}
          onClick={() => handleVerDetalle(record)}
        >
          Ver Detalle
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
          <div>
            <h2>Mis Servicios Asignados</h2>
            <p>Servicios que te han sido asignados</p>
          </div>
          <Button
            type="primary"
            icon={<FileTextOutlined />}
            onClick={fetchResumenDiario}
            style={{ marginTop: 8 }}
          >
            Resumen Diario
          </Button>
        </div>

        {servicios.length === 0 ? (
          <Empty description="No tienes servicios asignados" />
        ) : (
          <Table
            columns={columns}
            dataSource={servicios}
            rowKey="id"
            loading={loading}
            pagination={{ pageSize: 10 }}
          />
        )}

        {selectedServicio && (
          <Modal
            title={`Detalle del Servicio #${selectedServicio.id}`}
            open={modalVisible}
            onCancel={() => {
              setModalVisible(false);
              setSelectedServicio(null);
            }}
            footer={[
              <Button
                key="finalizar"
                type="primary"
                icon={<CheckOutlined />}
                onClick={handleFinalizarServicio}
                disabled={selectedServicio?.estado === 'completado'}
              >
                Finalizar Servicio
              </Button>,
              <Button key="close" onClick={() => {
                setModalVisible(false);
                setSelectedServicio(null);
              }}>
                Cerrar
              </Button>
            ]}
            width={window.innerWidth < 768 ? '95%' : 900}
            style={{ top: window.innerWidth < 768 ? 10 : 20 }}
            bodyStyle={{ maxHeight: window.innerWidth < 768 ? '80vh' : 'auto', overflowY: 'auto' }}
          >
            <Tabs activeKey={activeTab} onChange={setActiveTab} type="card">
              {/* Pestaña 1: Información General */}
              <Tabs.TabPane tab="Información General" key="1">
                <Descriptions bordered column={window.innerWidth < 768 ? 1 : 2}>
                  <Descriptions.Item label="Cliente">
                    {selectedServicio.cliente_nombre
                      ? `${selectedServicio.cliente_nombre} ${selectedServicio.cliente_apellido || ''}`.trim()
                      : '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Estado">
                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                      <Tag color={getEstadoColor(selectedServicio.estado)} style={{ fontSize: '14px', padding: '4px 12px' }}>
                        {getEstadoLabel(selectedServicio.estado)}
                      </Tag>
                      {getBotonesEstadoDisponibles(selectedServicio.estado).length > 0 && (
                        <Space wrap>
                          {getBotonesEstadoDisponibles(selectedServicio.estado).map((boton) => (
                            <Button
                              key={boton.estado}
                              type={boton.estado === 'completado' ? 'primary' : 'default'}
                              danger={boton.estado === 'cancelado'}
                              onClick={() => {
                                if (boton.estado === 'completado' || boton.estado === 'cancelado') {
                                  // Guardar el estado que se va a cambiar para usarlo en el modal
                                  setEstadoPendiente(boton.estado);
                                  handleFinalizarServicio();
                                } else {
                                  handleCambiarEstado(boton.estado);
                                }
                              }}
                              style={{ marginTop: 8 }}
                            >
                              {boton.label}
                            </Button>
                          ))}
                        </Space>
                      )}
                    </Space>
                  </Descriptions.Item>
                  <Descriptions.Item label="Lugar de Contacto" span={2}>
                    {selectedServicio.lugar_contacto || '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Lugar de Destino" span={2}>
                    {selectedServicio.lugar_destino || '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Placa">
                    {selectedServicio.placa || '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Tipo de Vehículo">
                    {selectedServicio.tipo_vehiculo || '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Marca">
                    {selectedServicio.marca_vehiculo || '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Modelo">
                    {selectedServicio.modelo_vehiculo || '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Año">
                    {selectedServicio.anio_vehiculo || '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Tipo de Servicio">
                    {selectedServicio.tipo_servicio_nombre || '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Aseguradora">
                    {selectedServicio.aseguradora_nombre || '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Km. Inicio">
                    {selectedServicio.km_inicio || '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Km. Fin">
                    {selectedServicio.km_fin || '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Total">
                    {selectedServicio.costo != null || selectedServicio.total != null
                      ? `S/ ${getMontosDesdeServicio(selectedServicio).total.toFixed(2)}`
                      : '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Fecha Solicitud">
                    {selectedServicio.fecha_solicitud
                      ? dayjs(selectedServicio.fecha_solicitud).format('DD/MM/YYYY HH:mm')
                      : '-'}
                  </Descriptions.Item>
                  <Descriptions.Item label="Observaciones" span={2}>
                    {selectedServicio.observaciones || '-'}
                  </Descriptions.Item>
                </Descriptions>
              </Tabs.TabPane>

              {/* Pestaña 2: Imágenes */}
              <Tabs.TabPane tab="Imágenes" key="2">
                <Divider>Imágenes del Servicio</Divider>

                <div style={{ marginBottom: 16 }}>
                  <Upload.Dragger
                    name="imagenes"
                    multiple
                    fileList={fileList}
                    accept="image/*"
                    disabled={selectedServicio?.estado === 'completado' || uploadingImages}
                    onChange={({ fileList: newFileList }) => {
                      // Asegurar que cada archivo tenga la propiedad descripcion
                      const updatedFileList = newFileList.map(f => ({
                        ...f,
                        descripcion: f.descripcion || ''
                      }));
                      setFileList(updatedFileList);
                    }}
                    customRequest={async ({ file, onSuccess, onError, onProgress }) => {
                      if (!selectedServicio || !selectedServicio.id) {
                        onError(new Error('No hay servicio seleccionado'));
                        message.error('No hay servicio seleccionado');
                        return;
                      }

                      // Simular progreso inicial
                      onProgress({ percent: 0 });

                      setUploadingImages(true);
                      try {
                        const formData = new FormData();
                        formData.append('imagenes[]', file);
                        formData.append('tipo', 'servicios');

                        onProgress({ percent: 30 });

                        const response = await api.post('/servicios/upload-images', formData, {
                          headers: {
                            'Content-Type': 'multipart/form-data',
                          },
                        });

                        onProgress({ percent: 70 });

                        if (response.data && response.data.urls && response.data.urls.length > 0) {
                          const imagenesActuales = selectedServicio.imagenes || [];
                          // Convertir array de URLs a array de objetos si es necesario
                          const imagenesNormalizadas = imagenesActuales.map(img =>
                            typeof img === 'string' ? { url: img, descripcion: '' } : img
                          );

                          // Agregar nueva imagen con descripción del fileList
                          const nuevaUrl = response.data.urls[0];
                          const descripcion = file.descripcion || '';
                          const nuevasImagenes = [...imagenesNormalizadas, { url: nuevaUrl, descripcion: descripcion }];

                          await api.put(`/servicios/${selectedServicio.id}`, {
                            imagenes: nuevasImagenes
                          });

                          onProgress({ percent: 100 });

                          // Actualizar el servicio seleccionado con las nuevas imágenes
                          setSelectedServicio({
                            ...selectedServicio,
                            imagenes: nuevasImagenes
                          });

                          // Refrescar la lista de servicios
                          await fetchServicios();

                          // Limpiar la lista de archivos después de subir
                          setTimeout(() => {
                            setFileList([]);
                          }, 500);

                          onSuccess('ok');
                          message.success('Imagen agregada exitosamente');
                        } else {
                          const errorMsg = response.data?.message || 'No se recibieron URLs de imágenes';
                          onError(new Error(errorMsg));
                          message.error(errorMsg);
                        }
                      } catch (error) {
                        console.error('Error al subir imagen:', error);
                        const errorMsg = error.response?.data?.message || error.message || 'Error al subir imagen';
                        onError(error);
                        message.error(errorMsg);
                      } finally {
                        setUploadingImages(false);
                      }
                    }}
                    onRemove={(file) => {
                      const newFileList = fileList.filter(item => item.uid !== file.uid);
                      setFileList(newFileList);
                      return true;
                    }}
                    showUploadList={{
                      showPreviewIcon: true,
                      showRemoveIcon: true,
                      showDownloadIcon: false,
                    }}
                  >
                    <p className="ant-upload-drag-icon">
                      <UploadOutlined style={{ fontSize: '48px', color: selectedServicio?.estado === 'completado' ? '#d9d9d9' : '#1890ff' }} />
                    </p>
                    <p className="ant-upload-text">
                      {selectedServicio?.estado === 'completado'
                        ? 'No se pueden agregar imágenes a servicios completados'
                        : 'Haz clic o arrastra imágenes aquí para agregar'}
                    </p>
                    {selectedServicio?.estado !== 'completado' && (
                      <p className="ant-upload-hint">
                        Soporta: JPG, PNG, GIF (máx. 10MB por imagen)
                      </p>
                    )}
                  </Upload.Dragger>
                  {/* Campo de descripción para la imagen que se está subiendo */}
                  {fileList.length > 0 && fileList[0].status === 'uploading' && (
                    <div style={{ marginTop: 16 }}>
                      <Input
                        placeholder="Agregar descripción de la imagen (opcional)"
                        value={fileList[0].descripcion || ''}
                        onChange={(e) => {
                          const updatedFileList = fileList.map((f, idx) =>
                            idx === 0 ? { ...f, descripcion: e.target.value } : f
                          );
                          setFileList(updatedFileList);
                        }}
                        style={{ width: '100%' }}
                      />
                    </div>
                  )}
                </div>

                {selectedServicio.imagenes && Array.isArray(selectedServicio.imagenes) && selectedServicio.imagenes.length > 0 ? (
                  <Row gutter={[8, 8]}>
                    {selectedServicio.imagenes.map((imagen, index) => {
                      // Manejar tanto formato antiguo (string) como nuevo (objeto)
                      const url = typeof imagen === 'object' && imagen.url ? imagen.url : imagen;
                      const descripcion = typeof imagen === 'object' && imagen.descripcion ? imagen.descripcion : '';
                      return (
                        <Col key={index} span={8}>
                          <div style={{ position: 'relative', marginBottom: 8 }}>
                            <Image
                              src={getImageUrl(url)}
                              alt={`Imagen ${index + 1}`}
                              style={{ width: '100%', borderRadius: 4 }}
                              preview
                            />
                            <Button
                              type="primary"
                              danger
                              icon={<DeleteOutlined />}
                              size="small"
                              style={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                              }}
                              onClick={() => handleDeleteImage(url, index)}
                            />
                          </div>
                          {descripcion && (
                            <div style={{
                              padding: 8,
                              backgroundColor: '#f5f5f5',
                              borderRadius: 4,
                              fontSize: '12px',
                              color: '#666',
                              marginTop: 4
                            }}>
                              {descripcion}
                            </div>
                          )}
                        </Col>
                      );
                    })}
                  </Row>
                ) : (
                  <Empty description="No hay imágenes agregadas" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                )}
              </Tabs.TabPane>

              {/* Pestaña 3: Inspección */}
              <Tabs.TabPane tab="Inspección" key="3">
                <Divider>Plano Interactivo - Marcado de Fallas Mecánicas</Divider>
                <Form
                  form={formPlanoChecklist}
                  layout="vertical"
                  onFinish={handleGuardarPlanoChecklist}
                >
                  <Form.Item
                    name="fallas_mecanicas"
                    key={`fallas-${editandoPlanoChecklist}`}
                  >
                    <PlanoCarro disabled={!editandoPlanoChecklist} />
                  </Form.Item>

                  <Divider>Checklist de Elementos del Vehículo</Divider>
                  <Form.Item key={`checklist-${editandoPlanoChecklist}`} shouldUpdate={() => true}>
                    {() => {
                      // Agrupar elementos en pares para mostrar 2 por línea
                      const groupedItems = [];
                      for (let i = 0; i < checklistItems.length; i += 2) {
                        groupedItems.push(checklistItems.slice(i, i + 2));
                      }

                      return (
                        <div style={{ marginBottom: 16 }}>
                          {groupedItems.map((pair, pairIndex) => (
                            <Row gutter={[16, 8]} key={pairIndex} style={{ marginBottom: 8 }}>
                              {pair.map((item) => {
                                const currentValue = formPlanoChecklist.getFieldValue(item.key);
                                const isSI = currentValue === 'SI';
                                const isNO = currentValue === 'NO';

                                return (
                                  <Col span={12} key={item.key}>
                                    <Row gutter={[8, 0]}>
                                      <Col span={12} style={{ display: 'flex', alignItems: 'center', padding: '0 8px', fontSize: '13px' }}>
                                        {item.label}
                                      </Col>
                                      <Col span={6}>
                                        <Form.Item name={item.key} style={{ marginBottom: 0 }}>
                                          <div
                                            style={{
                                              padding: '8px 12px',
                                              border: '1px solid #d9d9d9',
                                              borderRadius: '2px',
                                              textAlign: 'center',
                                              cursor: !editandoPlanoChecklist ? 'not-allowed' : 'pointer',
                                              background: isSI ? '#e6f7ff' : '#fff',
                                              borderColor: isSI ? '#1890ff' : '#d9d9d9',
                                              transition: 'all 0.2s',
                                              userSelect: 'none',
                                              minHeight: '36px',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              fontSize: '13px',
                                              opacity: !editandoPlanoChecklist ? 0.6 : 1,
                                            }}
                                            onClick={() => {
                                              if (!editandoPlanoChecklist) return;
                                              if (isSI) {
                                                formPlanoChecklist.setFieldsValue({ [item.key]: undefined });
                                              } else {
                                                formPlanoChecklist.setFieldsValue({ [item.key]: 'SI' });
                                              }
                                            }}
                                            onMouseEnter={(e) => {
                                              if (!isSI && editandoPlanoChecklist) {
                                                e.currentTarget.style.background = '#f5f5f5';
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if (!isSI) {
                                                e.currentTarget.style.background = '#fff';
                                              }
                                            }}
                                          >
                                            SI
                                          </div>
                                        </Form.Item>
                                      </Col>
                                      <Col span={6}>
                                        <Form.Item name={item.key} style={{ marginBottom: 0 }}>
                                          <div
                                            style={{
                                              padding: '8px 12px',
                                              border: '1px solid #d9d9d9',
                                              borderRadius: '2px',
                                              textAlign: 'center',
                                              cursor: !editandoPlanoChecklist ? 'not-allowed' : 'pointer',
                                              background: isNO ? '#fff1f0' : '#fff',
                                              borderColor: isNO ? '#ff4d4f' : '#d9d9d9',
                                              transition: 'all 0.2s',
                                              userSelect: 'none',
                                              minHeight: '36px',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              fontSize: '13px',
                                              opacity: !editandoPlanoChecklist ? 0.6 : 1,
                                            }}
                                            onClick={() => {
                                              if (!editandoPlanoChecklist) return;
                                              if (isNO) {
                                                formPlanoChecklist.setFieldsValue({ [item.key]: undefined });
                                              } else {
                                                formPlanoChecklist.setFieldsValue({ [item.key]: 'NO' });
                                              }
                                            }}
                                            onMouseEnter={(e) => {
                                              if (!isNO && editandoPlanoChecklist) {
                                                e.currentTarget.style.background = '#f5f5f5';
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if (!isNO) {
                                                e.currentTarget.style.background = '#fff';
                                              }
                                            }}
                                          >
                                            NO
                                          </div>
                                        </Form.Item>
                                      </Col>
                                    </Row>
                                  </Col>
                                );
                              })}
                            </Row>
                          ))}
                        </div>
                      );
                    }}
                  </Form.Item>

                  <Form.Item>
                    <Space>
                      <Button
                        type="primary"
                        icon={<SaveOutlined />}
                        htmlType="submit"
                      >
                        Guardar Cambios
                      </Button>
                      <Button
                        onClick={() => {
                          // Recargar valores originales sin guardar
                          const formValues = {
                            fallas_mecanicas: selectedServicio.fallas_mecanicas || [],
                          };
                          if (selectedServicio.checklist) {
                            Object.keys(selectedServicio.checklist).forEach(key => {
                              if (key !== 'id' && key !== 'servicio_id') {
                                formValues[key] = selectedServicio.checklist[key];
                              }
                            });
                          }
                          formPlanoChecklist.setFieldsValue(formValues);
                        }}
                      >
                        Cancelar
                      </Button>
                    </Space>
                  </Form.Item>
                </Form>
              </Tabs.TabPane>

              {/* Pestaña 4: Seguimiento */}
              <Tabs.TabPane tab="Seguimiento" key="4">
                <div style={{ display: 'flex', flexDirection: 'column', height: '500px' }}>
                  {/* Área de mensajes */}
                  <div style={{ flex: 1, overflowY: 'auto', border: '1px solid #d9d9d9', borderRadius: '4px', padding: '16px', marginBottom: '16px', background: '#fafafa' }}>
                    <Spin spinning={cargandoSeguimiento}>
                      <List
                        dataSource={seguimientoMensajes}
                        renderItem={(mensaje) => {
                          const esMio = mensaje.usuario_id === user?.id;
                          return (
                            <List.Item style={{
                              justifyContent: esMio ? 'flex-end' : 'flex-start',
                              padding: '8px 0',
                              borderBottom: '1px solid #f0f0f0'
                            }}>
                              <div style={{
                                maxWidth: '70%',
                                background: esMio ? '#1890ff' : '#fff',
                                color: esMio ? '#fff' : '#000',
                                padding: '12px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                              }}>
                                <div style={{ marginBottom: '8px', fontSize: '12px', opacity: 0.8 }}>
                                  {mensaje.usuario_nombre} ({mensaje.usuario_rol === 'admin' ? 'Admin' : 'Operador'})
                                  <span style={{ marginLeft: '8px' }}>
                                    {dayjs(mensaje.fecha_registro).format('DD/MM/YYYY HH:mm')}
                                  </span>
                                  {esMio && (
                                    <Button
                                      type="link"
                                      danger
                                      size="small"
                                      onClick={() => handleEliminarMensaje(mensaje.id)}
                                      style={{ float: 'right', padding: 0, color: esMio ? '#fff' : '#ff4d4f' }}
                                    >
                                      Eliminar
                                    </Button>
                                  )}
                                </div>
                                {mensaje.mensaje && (
                                  <div style={{ marginBottom: mensaje.imagen ? '8px' : 0 }}>
                                    {mensaje.mensaje}
                                  </div>
                                )}
                                {mensaje.imagen && (
                                  <div>
                                    <Image
                                      src={getImageUrl(mensaje.imagen)}
                                      alt="Imagen de seguimiento"
                                      style={{ maxWidth: '100%', borderRadius: '4px' }}
                                      preview={{
                                        mask: 'Ver imagen'
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            </List.Item>
                          );
                        }}
                      />
                    </Spin>
                  </div>

                  {/* Área de envío */}
                  <div style={{ borderTop: '1px solid #d9d9d9', paddingTop: '16px' }}>
                    <Space direction="vertical" style={{ width: '100%' }} size="middle">
                      <Input.TextArea
                        placeholder="Escribe un mensaje..."
                        value={nuevoMensaje}
                        onChange={(e) => setNuevoMensaje(e.target.value)}
                        rows={3}
                        onPressEnter={(e) => {
                          if (e.shiftKey) return; // Permitir nueva línea con Shift+Enter
                          e.preventDefault();
                          handleEnviarMensaje();
                        }}
                      />
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Upload
                          beforeUpload={(file) => {
                            setImagenSeguimiento(file);
                            return false;
                          }}
                          accept="image/*"
                          showUploadList={false}
                        >
                          <Button icon={<InboxOutlined />}>Adjuntar Imagen</Button>
                        </Upload>
                        {imagenSeguimiento && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: '12px', color: '#666' }}>
                              {imagenSeguimiento.name}
                            </span>
                            <Button
                              type="link"
                              danger
                              size="small"
                              onClick={() => setImagenSeguimiento(null)}
                            >
                              Quitar
                            </Button>
                          </div>
                        )}
                        <Button
                          type="primary"
                          onClick={handleEnviarMensaje}
                          disabled={!nuevoMensaje.trim() && !imagenSeguimiento}
                        >
                          Enviar
                        </Button>
                      </div>
                    </Space>
                  </div>
                </div>
              </Tabs.TabPane>
            </Tabs>
          </Modal>
        )}

        {/* Modal para finalizar/cancelar servicio con kilometraje */}
        <Modal
          title={estadoPendiente === 'cancelado' ? 'Cancelar Servicio' : 'Finalizar Servicio'}
          open={finalizarModalVisible}
          onCancel={() => {
            setFinalizarModalVisible(false);
            formFinalizar.resetFields();
            setEstadoPendiente('completado');
          }}
          footer={null}
          width={500}
        >
          <Form
            form={formFinalizar}
            layout="vertical"
            onFinish={(values) => handleConfirmarFinalizar(values, estadoPendiente)}
            initialValues={{
              km_fin: null
            }}
          >
            <Form.Item
              name="km_fin"
              label="Kilometraje Final de la Unidad"
              rules={[
                { required: true, message: 'Ingresa el kilometraje final' },
                { type: 'number', min: 0, message: 'El kilometraje debe ser mayor o igual a 0' }
              ]}
            >
              <InputNumber
                style={{ width: '100%' }}
                placeholder="Ingresa el kilometraje final"
                min={0}
                precision={2}
                formatter={(value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                parser={(value) => value ? value.replace(/\$\s?|(,*)/g, '') : ''}
              />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  danger={estadoPendiente === 'cancelado'}
                >
                  {estadoPendiente === 'cancelado' ? 'Cancelar Servicio' : 'Finalizar Servicio'}
                </Button>
                <Button onClick={() => {
                  setFinalizarModalVisible(false);
                  formFinalizar.resetFields();
                  setEstadoPendiente('completado');
                }}>
                  Cancelar
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>

        {/* Modal de Resumen Diario */}
        <Modal
          title="Resumen Diario"
          open={resumenModalVisible}
          onCancel={() => {
            setResumenModalVisible(false);
            setCajaChica(null);
            setGastosCajaChica([]);
          }}
          footer={[
            <Button
              key="export"
              type="primary"
              icon={<FileTextOutlined />}
              onClick={handleExportarResumenPDF}
            >
              Exportar PDF
            </Button>,
            <Button key="close" onClick={() => {
              setResumenModalVisible(false);
              setCajaChica(null);
              setGastosCajaChica([]);
            }}>
              Cerrar
            </Button>
          ]}
          width={800}
        >
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab="Resumen de Servicios" key="1">
              {(() => {
                const resumen = calcularResumenServicios();
                return (
                  <div>
                    <Row gutter={16} style={{ marginBottom: 24 }}>
                      <Col xs={12} sm={6}>
                        <Card>
                          <Statistic
                            title="Total Servicios"
                            value={resumen.total}
                            valueStyle={{ color: '#1890ff' }}
                          />
                        </Card>
                      </Col>
                      <Col xs={12} sm={6}>
                        <Card>
                          <Statistic
                            title="Completados"
                            value={resumen.completados}
                            valueStyle={{ color: '#3f8600' }}
                          />
                        </Card>
                      </Col>
                      <Col xs={12} sm={6}>
                        <Card>
                          <Statistic
                            title="En Proceso"
                            value={resumen.enProceso}
                            valueStyle={{ color: '#1890ff' }}
                          />
                        </Card>
                      </Col>
                      <Col xs={12} sm={6}>
                        <Card>
                          <Statistic
                            title="Pendientes"
                            value={resumen.pendientes}
                            valueStyle={{ color: '#faad14' }}
                          />
                        </Card>
                      </Col>
                    </Row>
                    <Divider />
                    <h3>Servicios del Día</h3>
                    <Table
                      columns={[
                        { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
                        {
                          title: 'Cliente',
                          key: 'cliente',
                          render: (_, record) => {
                            if (record.cliente_nombre) {
                              return `${record.cliente_nombre} ${record.cliente_apellido || ''}`.trim();
                            }
                            return '-';
                          }
                        },
                        {
                          title: 'Estado',
                          dataIndex: 'estado',
                          render: (estado) => (
                            <Tag color={getEstadoColor(estado)}>
                              {getEstadoLabel(estado)}
                            </Tag>
                          )
                        },
                        {
                          title: 'Fecha',
                          dataIndex: 'fecha_solicitud',
                          render: (fecha) => fecha ? dayjs(fecha).format('DD/MM/YYYY HH:mm') : '-'
                        },
                      ]}
                      dataSource={servicios.filter(s => {
                        if (s.trabajador_id && s.trabajador_id.toString() === user?.personal_id?.toString()) {
                          const fechaServicio = dayjs(s.fecha_solicitud || s.created_at);
                          return fechaServicio.isSame(dayjs(), 'day');
                        }
                        return false;
                      })}
                      rowKey="id"
                      pagination={false}
                      size="small"
                    />
                  </div>
                );
              })()}
            </Tabs.TabPane>
            <Tabs.TabPane tab="Resumen de Caja Chica" key="2">
              {cajaChica ? (() => {
                const resumenCaja = calcularResumenCajaChica();
                return (
                  <div>
                    <Descriptions bordered column={1} style={{ marginBottom: 24 }}>
                      <Descriptions.Item label="Estado">
                        <Tag color="blue">En Curso</Tag>
                      </Descriptions.Item>
                      <Descriptions.Item label="Monto Asignado (Efectivo)">
                        S/ {resumenCaja.montoAsignado.toFixed(2)}
                      </Descriptions.Item>
                      <Descriptions.Item label="Efectivo Disponible">
                        S/ {resumenCaja.efectivoDisponible.toFixed(2)}
                      </Descriptions.Item>
                      <Descriptions.Item label="Gastos en Efectivo">
                        S/ {resumenCaja.totalGastosEfectivo.toFixed(2)}
                      </Descriptions.Item>
                      <Descriptions.Item label="Tarjeta de Combustible">
                        S/ {resumenCaja.tarjetaCombustible.toFixed(2)}
                      </Descriptions.Item>
                      <Descriptions.Item label="Tarjeta Disponible">
                        S/ {resumenCaja.tarjetaDisponible.toFixed(2)}
                      </Descriptions.Item>
                      <Descriptions.Item label="Gastos en Tarjeta">
                        S/ {resumenCaja.totalGastosTarjeta.toFixed(2)}
                      </Descriptions.Item>
                      <Descriptions.Item label="Total de Gastos">
                        {resumenCaja.totalGastos}
                      </Descriptions.Item>
                    </Descriptions>
                    <Divider />
                    <h3>Gastos Registrados</h3>
                    <Table
                      columns={[
                        { title: 'Fecha', dataIndex: 'fecha_gasto', key: 'fecha_gasto', render: (fecha) => fecha ? dayjs(fecha).format('DD/MM/YYYY') : '-' },
                        { title: 'Tipo', dataIndex: 'tipo_gasto', key: 'tipo_gasto' },
                        { title: 'Tipo de Pago', dataIndex: 'tipo_pago', key: 'tipo_pago', render: (tipo) => tipo === 'tarjeta' ? 'Tarjeta' : 'Efectivo' },
                        { title: 'Monto', dataIndex: 'monto', key: 'monto', render: (monto) => `S/ ${parseFloat(monto || 0).toFixed(2)}` },
                        {
                          title: 'Estado', dataIndex: 'estado', key: 'estado', render: (estado) => (
                            <Tag color={estado === 'aprobado' ? 'green' : estado === 'rechazado' ? 'red' : 'orange'}>
                              {estado === 'aprobado' ? 'Aprobado' : estado === 'rechazado' ? 'Rechazado' : 'Pendiente'}
                            </Tag>
                          )
                        },
                      ]}
                      dataSource={gastosCajaChica}
                      rowKey="id"
                      pagination={false}
                      size="small"
                    />
                  </div>
                );
              })() : (
                <Empty description="No tienes una caja chica en curso" />
              )}
            </Tabs.TabPane>
          </Tabs>
        </Modal>
      </Card>
    </div>
  );
};

export default MisServicios;

